export default __webpack_public_path__ + "static/media/ic_trash_gray.41f51a4f.svg";